export const onMouseMove = ({
  hotspotType,
  drawing,
  startXY,
  root,
  inverseScale,
  rectState,
  pubSub,
}) => {
  return e => {
    if (!drawing.current) {
      return;
    }

    const { startX, startY } = startXY.current;

    const clientX =
      (e.clientX - root.current!.getBoundingClientRect().left) * inverseScale;
    const clientY =
      (e.clientY - root.current!.getBoundingClientRect().top) * inverseScale;

    const negX = clientX < startX;
    const negY = clientY < startY;

    const x = negX ? Math.abs(clientX) : startX;
    const y = negY ? Math.abs(clientY) : startY;
    const w = Math.abs(clientX - startX);
    const h = Math.abs(clientY - startY);

    rectState.current = {
      x,
      y,
      w,
      h,
    };

    pubSub.publish('UPDATE_HOTSPOT_POINTS', {
      points: rectState.current,
      updateRectangleHotspotLocalState: true,
    });
  };
};
